import FooterSection from './FooterSection';

const TermsAndConditions = () => {
  const terms = {
    header: 'Terms and Conditions',
    section1_title: '1. Introduction',
    section1_text:
      'Welcome to the EnRiCH Digital Learning Platform (EnRiCH DLP). The Platform provides high-quality digital learning experiences for Frontline Community Health Workers (FCHWs) and approved users. By using the Service, you agree to these Terms and our Privacy Policy.',
    section2_title: '2. Definitions',
    section2_item1:
      '“Service” means the EnRiCH DLP learning application and associated systems.',
    section2_item2:
      '“Content” means courses, videos, text, images, audio, quizzes, assessments, and resources available on the Service.',
    section2_item3:
      '“User,” “you,” or “Student” refers to anyone accessing the Service.',
    section2_item4:
      '“Instructor” refers to content creators contributing materials.',
    section2_item5: '“Account” means your user profile and login credentials.',
    section2_item6: '“Website” refers to www.enrichdlp.org operated by CARE.',
    section3_title: '3. Eligibility',
    section3_item1: 'Provide accurate, complete, and current information.',
    section3_item2: 'Update your information when changes occur.',
    section3_item3:
      'Be at least 18 years old or meet local minimum age requirements.',
    section3_item4: 'Use the Platform only for lawful purposes.',
    section4_title: '4. Accounts and Security',
    section4_item1: 'You are responsible for safeguarding your login credentials.',
    section4_item2:
      'We may suspend or terminate accounts that violate these Terms.',
    section5_title: '5. Use of the Service',
    section5_subA: 'a. License',
    section5_subA_text:
      'We grant you a limited, non-exclusive, revocable license to access and use the Service for personal learning.',
    section5_subB: 'b. Prohibited Conduct',
    section5_b1: 'Infringing on intellectual property.',
    section5_b2: 'Copying or distributing content beyond permitted use.',
    section5_b3: 'Bypassing security controls.',
    section5_b4: 'Uploading viruses or harmful code.',
    section5_b5: 'Harassing or threatening other users.',
    section5_b6: 'Cheating or falsifying assessments.',
    section5_b7: 'Manipulating or forging certificates.',
    section5_b8: 'Disrupting platform operations.',
    section5_subC: 'c. Ownership',
    section5_subC_text:
      'All platform content remains the property of CARE, instructors, and licensors.',
    section6_title: '6. Content and Intellectual Property',
    section6_sub1: 'User-Generated Content',
    section6_item1:
      'You grant us a global license to use content you submit to improve the Service.',
    section6_item2:
      'You must ensure your content does not violate laws or rights.',
    section6_sub2: 'Instructor Rights',
    section6_sub2_text:
      'Instructors retain copyright to their content. You may not remove copyright notices.',
    section7_title: '7. Courses, Assessments, and Certifications',
    section7_item1: 'All course enrollments are free.',
    section7_item2:
      'Assessments measure learning and follow provider criteria.',
    section7_item3:
      'Certificates are issued only after completing required modules.',
    section8_title: '8. Payments and Refunds',
    section8_text:
      'Phones and tools assigned remain property of the project and must be replaced if lost or damaged.',
    section9_title: '9. Privacy and Data Protection',
    section9_item1:
      'We collect registration data, progress, scores, and certificate information.',
    section9_item2:
      'Data is used to deliver training, track progress, issue certificates, and provide support.',
    section9_item3:
      'Data is stored securely and not sold or used for marketing.',
    section10_title: '10. Third-Party Content and Links',
    section10_text:
      'External links may appear. We do not endorse third-party material.',
    section11_title: '11. Term, Termination, and Suspension',
    section11_item1: 'You may stop using the Service anytime.',
    section11_item2: 'We may suspend accounts that violate Terms.',
    section11_item3: 'Some data may be retained for legal obligations.',
    section12_title: '12. Disclaimers and Limitation of Liability',
    section12_text:
      'Modules follow State Ministry of Health curriculum for FCHWs and medical personnel.',
    section13_title: '13. Indemnification',
    section13_text:
      'You agree to indemnify CARE and partners from claims arising from misuse of the Service.',
    section14_title: '14. Governing Law and Dispute Resolution',
    section14_text: 'These Terms are governed by the laws of Nigeria.',
    section15_title: '15. Changes to Terms',
    section15_text: 'We may revise Terms. Continued use means acceptance.',
    section16_title: '16. Language and Localization',
    section16_text:
      'Where translations differ, the English version prevails.',
    section17_title: '17. Export Controls',
    section17_text:
      'You may not export restricted technology in violation of laws.',
    section18_title: '18. Feedback and Suggestions',
    section18_text: 'Feedback may be used without obligation.',
    section19_title: '19. Contact Information',
    section19_text:
      'For questions: CARE – EnRiCH Project Team, Email: Nga.enrichdpl@care.org',
  };

  return (
    <>
      <div className='p-8 max-w-4xl mx-auto space-y-6'>
        <h1 className='text-3xl font-bold'>{terms.header}</h1>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section1_title}</h2>
        <p>{terms.section1_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section2_title}</h2>
        <ul className='list-disc ml-6 space-y-1'>
          <li>{terms.section2_item1}</li>
          <li>{terms.section2_item2}</li>
          <li>{terms.section2_item3}</li>
          <li>{terms.section2_item4}</li>
          <li>{terms.section2_item5}</li>
          <li>{terms.section2_item6}</li>
        </ul>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section3_title}</h2>
        <ul className='list-disc ml-6 space-y-1'>
          <li>{terms.section3_item1}</li>
          <li>{terms.section3_item2}</li>
          <li>{terms.section3_item3}</li>
          <li>{terms.section3_item4}</li>
        </ul>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section4_title}</h2>
        <ul className='list-disc ml-6 space-y-1'>
          <li>{terms.section4_item1}</li>
          <li>{terms.section4_item2}</li>
        </ul>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section5_title}</h2>
        <h3 className='font-semibold'>{terms.section5_subA}</h3>
        <p className='mb-3'>{terms.section5_subA_text}</p>
        <h3 className='font-semibold'>{terms.section5_subB}</h3>
        <ul className='list-disc ml-6 space-y-1 mb-3'>
          <li>{terms.section5_b1}</li>
          <li>{terms.section5_b2}</li>
          <li>{terms.section5_b3}</li>
          <li>{terms.section5_b4}</li>
          <li>{terms.section5_b5}</li>
          <li>{terms.section5_b6}</li>
          <li>{terms.section5_b7}</li>
          <li>{terms.section5_b8}</li>
        </ul>
        <h3 className='font-semibold'>{terms.section5_subC}</h3>
        <p>{terms.section5_subC_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section6_title}</h2>
        <h3 className='font-semibold'>{terms.section6_sub1}</h3>
        <ul className='list-disc ml-6 space-y-1 mb-3'>
          <li>{terms.section6_item1}</li>
          <li>{terms.section6_item2}</li>
        </ul>
        <h3 className='font-semibold'>{terms.section6_sub2}</h3>
        <p>{terms.section6_sub2_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section7_title}</h2>
        <ul className='list-disc ml-6 space-y-1'>
          <li>{terms.section7_item1}</li>
          <li>{terms.section7_item2}</li>
          <li>{terms.section7_item3}</li>
        </ul>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section8_title}</h2>
        <p>{terms.section8_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section9_title}</h2>
        <ul className='list-disc ml-6 space-y-1'>
          <li>{terms.section9_item1}</li>
          <li>{terms.section9_item2}</li>
          <li>{terms.section9_item3}</li>
        </ul>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section10_title}</h2>
        <p>{terms.section10_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section11_title}</h2>
        <ul className='list-disc ml-6 space-y-1'>
          <li>{terms.section11_item1}</li>
          <li>{terms.section11_item2}</li>
          <li>{terms.section11_item3}</li>
        </ul>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section12_title}</h2>
        <p>{terms.section12_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section13_title}</h2>
        <p>{terms.section13_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section14_title}</h2>
        <p>{terms.section14_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section15_title}</h2>
        <p>{terms.section15_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section16_title}</h2>
        <p>{terms.section16_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section17_title}</h2>
        <p>{terms.section17_text}</p>
      </section>

      <section>
        <h2 className='text-xl font-semibold mb-2'>{terms.section18_title}</h2>
        <p>{terms.section18_text}</p>
      </section>

        <section>
          <h2 className='text-xl font-semibold mb-2'>{terms.section19_title}</h2>
          <p>{terms.section19_text}</p>
        </section>
      </div>
      <FooterSection />
    </>
  );
};

export default TermsAndConditions;